export default [
    {
        path: '/emons/daily-balance',
        name: 'emons_daily_balance',
        component: () => import('@src/emons/daily-balance'),
        meta: {
            title: 'Tagesabschluss Emons',
            role: 'ROLE_EMONS_DAILY_BALANCE',
        },
    },
];
